import { render, staticRenderFns } from "./TotalClaims.vue?vue&type=template&id=54865ea5&scoped=true&"
import script from "./TotalClaims.vue?vue&type=script&lang=js&"
export * from "./TotalClaims.vue?vue&type=script&lang=js&"
import style0 from "./TotalClaims.vue?vue&type=style&index=0&id=54865ea5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54865ea5",
  null
  
)

export default component.exports